import React from "react";
import { Button } from "antd";
import styled from "styled-components";
import { Box } from "reflexbox/styled-components";
import { withLocalizeStrings } from "../../../languages/Localize";

const StyledMountainButton = styled(Button)`
    width: 100%;
    height: 24px;
    ${({ theme }) => theme.mediaQueries.small} {
        height: 28px;
    }
    background-color: ${({ theme }) => theme.colors.white};
    text-align: center;
    border: none;
    color: ${({ theme }) => theme.colors.primary};
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    ${({ theme }) => theme.mediaQueries.smallMax} {
        font-size: 10px;
    }
    ${({ theme }) => theme.mediaQueries.small} {
        font-size: 12px;
    }
    ${({ theme }) => theme.mediaQueries.medium} {
        font-size: 14px;
    }
    &.ant-btn {
        padding: 0 4px;
    }
    &:hover,
    &:focus {
        background-color: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.primary};
        outline: none;
    }
`;

const LocationMountainButton = ({ strings, path }) => {
    return (
        <Box>
            <StyledMountainButton>
                <a href={path}>{strings.location.BTN_RESERVATIONS}</a>
            </StyledMountainButton>
        </Box>
    );
};

export default withLocalizeStrings(LocationMountainButton);
